import React from 'react';
import { compose, pure } from 'recompose';
// import { withStyles } from '@material-ui/core/styles';
// import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// const styles = {};

const enhance = compose(pure);

const GochiTableBody = enhance(
  ({
    gochiBillNo,
    gochiBillId,
    shopId,
    shopName,
    groupId,
    groupName,
    emailBuy,
    gochiType,
    gochiUserType,
    amount,
    taxAmount,
    createdAt,
    couponCount,
    paymentType,
    chargeAmount
  }) => {
    return (
      <TableRow>
        <TableCell>{gochiBillNo}</TableCell>
        <TableCell>{gochiBillId}</TableCell>
        <TableCell>{shopId}</TableCell>
        <TableCell>{shopName}</TableCell>
        <TableCell>{groupId}</TableCell>
        <TableCell>{groupName}</TableCell>
        <TableCell>{emailBuy}</TableCell>
        <TableCell>{gochiType}</TableCell>
        <TableCell>{gochiUserType}</TableCell>
        <TableCell>{amount}</TableCell>
        <TableCell>{taxAmount}</TableCell>
        <TableCell>{amount && taxAmount ? amount + taxAmount : null}</TableCell>
        <TableCell>{createdAt}</TableCell>
        <TableCell>{couponCount}</TableCell>
        <TableCell>{paymentType}</TableCell>
        <TableCell>{chargeAmount}</TableCell>
      </TableRow>
    );
  }
);

export default GochiTableBody;
